import { useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { purchaseCredits } from '../lib/api'

export default function InsufficientCreditsModal({ onClose }) {
  const navigate = useNavigate()
  const [loading, setLoading] = useState(null)
  const [error, setError] = useState(null)

  const handleBuy = async (quantity) => {
    setLoading(quantity)
    setError(null)
    try {
      const { url } = await purchaseCredits(quantity)
      if (url) window.location.href = url
    } catch (err) {
      setError(err.message)
      setLoading(null)
    }
  }

  const packs = [
    { quantity: 1, credits: 100, price: '$1' },
    { quantity: 2, credits: 200, price: '$2' },
    { quantity: 5, credits: 500, price: '$5' },
  ]

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center p-4">
      <div className="absolute inset-0 bg-black/60 backdrop-blur-sm" onClick={onClose} />
      <div className="relative bg-[#111827] border border-white/10 rounded-2xl p-8 max-w-md w-full shadow-2xl">
        <button
          onClick={onClose}
          className="absolute top-4 right-4 text-gray-500 hover:text-white transition text-xl"
        >
          &times;
        </button>

        <div className="text-center mb-6">
          <div className="text-4xl mb-3">0</div>
          <h3
            className="text-xl font-bold text-white mb-2"
            style={{ fontFamily: "'Orbitron', sans-serif" }}
          >
            Out of Credits
          </h3>
          <p className="text-gray-400 text-sm">
            Purchase credits to continue scanning, or upgrade your plan for more monthly credits.
          </p>
        </div>

        {error && (
          <div className="bg-red-500/10 border border-red-500/30 rounded-lg p-3 mb-4 text-red-400 text-sm text-center">
            {error}
          </div>
        )}

        <div className="space-y-3 mb-6">
          {packs.map((pack) => (
            <button
              key={pack.quantity}
              onClick={() => handleBuy(pack.quantity)}
              disabled={loading !== null}
              className="w-full flex items-center justify-between p-4 rounded-xl border border-emerald-500/20 bg-emerald-500/5 hover:bg-emerald-500/15 transition group disabled:opacity-50"
            >
              <div className="text-left">
                <span className="text-emerald-400 font-semibold">{pack.credits} Credits</span>
                <span className="text-gray-500 text-sm ml-2">{pack.quantity} pack{pack.quantity > 1 ? 's' : ''}</span>
              </div>
              <span className="text-white font-bold group-hover:text-emerald-400 transition">
                {loading === pack.quantity ? 'Redirecting...' : pack.price}
              </span>
            </button>
          ))}
        </div>

        <div className="text-center">
          <button
            onClick={() => { onClose(); navigate('/plans') }}
            className="text-cyan-400 hover:text-cyan-300 text-sm transition"
          >
            Or upgrade your plan for more monthly credits &rarr;
          </button>
        </div>
      </div>
    </div>
  )
}
